import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faHome,
    faUser,
    faUserPlus,
    faSignInAlt,
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import VueVideoPlayer from 'vue-video-player'
import VueExcelEditor from 'vue-excel-editor'

import * as Sentry from "@sentry/vue";

// require videojs style
import 'video.js/dist/video-js.css'

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;
require('dotenv').config()
Vue.use(VeeValidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(Buefy)
Vue.use(VueVideoPlayer,
    /* {
  options: global default options,
  events: global videojs events
} */
)
Vue.use(VueExcelEditor)

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL + '/api/';
axios.defaults.headers.common['Content-Type'] = 'application/json';

Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY,
    environment: process.env.VUE_APP_NODE_ENV + ' FE',
    integrations: [
        Sentry.replayIntegration(),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0,
});
Vue.prototype.$eventHub = new Vue();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.directive('click-outside', {
    bind: function(element, binding, vnode) {
        element.clickOutsideEvent = function(event) { //  check that click was outside the el and his children
            if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
                // binding.value(); run the arg
            }
        };
        document.body.addEventListener('click', element.clickOutsideEvent)
    },
    unbind: function(element) {
        document.body.removeEventListener('click', element.clickOutsideEvent)
    }
});